import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalErrorService } from 'src/app/services/shared/modal-error.service';
import { Error } from 'src/app/models/error';

@Component({
  selector: 'app-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.scss'],
})
export class ModalErrorComponent implements OnInit {
  public modalRef: any;
  public errors: Error[];
  @ViewChild('content') content: TemplateRef<any>;

  private modal_opened = false;

  constructor(private modalService: NgbModal, public modalErrorService: ModalErrorService) {}

  ngOnInit(): void {
    this.modalErrorService.sharedModalOpen.subscribe((value) => {
      this.errors = value;
      if (Object.keys(this.errors).length > 0 && !this.modal_opened) {
        this.open();
      }
    });
  }
  open() {
    this.modal_opened = true;
    this.modalRef = this.modalService.open(this.content, { ariaLabelledBy: 'error-modal', backdropClass: 'backdrop-modal-error' });
    this.modalRef.result.then(() => {}, () => { this.close()})
  }

  close() {
    this.modalErrorService.cleanErrors();
    this.modal_opened = false;
    this.modalRef.dismiss();
  }

  confirm() {
    this.modalErrorService.cleanErrors();
    this.modal_opened = false;
    this.close();
  }
}
